import React from "react";
import { Select } from "antd";
import { useSelector } from "react-redux";
import { selectResolutions } from "../../../../core/data/redux/projects/selectors";
import type { Resolution } from "../../../../core/data/redux/projects/types";

interface ResolutionPickerProps {
  value: number | null | undefined;
  onChange: (resolutionId: number | null) => void;
  size?: "small" | "middle" | "large";
  disabled?: boolean;
}

const ResolutionPicker: React.FC<ResolutionPickerProps> = ({
  value,
  onChange,
  size = "middle",
  disabled,
}) => {
  const resolutions = useSelector(selectResolutions);

  return (
    <Select
      allowClear
      size={size}
      style={{ height: 36 }}
      className="w-100"
      placeholder="Select resolution"
      value={value ?? undefined}
      onChange={(v) => onChange(v ?? null)}
      disabled={disabled}
      options={resolutions.map((r: Resolution) => ({
        value: r.id,
        label: `${r.name}${r.is_default ? " (default)" : ""}`,
      }))}
    />
  );
};

export default ResolutionPicker;
